import React from "react";
import TrackList from "../components/trackList";

const CryptoSummary = () => {
  return (
    <div className="container">
      <TrackList />
    </div>
  );
};

export default CryptoSummary;
